import throttle from "lodash/throttle";
import { applyMiddleware, compose, createStore } from "redux";
import thunk from "redux-thunk";

import { loadState, saveState } from "./helpers";
import rootReducer from "./reducers";

export const store = createStore(
  rootReducer,
  loadState(),
  compose(applyMiddleware(thunk))
);

store.subscribe(throttle(() => saveState(store.getState()), 1000));
